import React, { useContext } from "react";
import "./App.css";
import WebFont from "webfontloader";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { CategoriasContext, CategoriasProvider } from "./peticiones_API/Peticiones_Categorias";
import { HelmetProvider, Helmet } from 'react-helmet-async';

// Componentes
import Cursos from "./assets/componentes/Cursos";
import ConvocatoriaSinSub from "./assets/componentes/ConvocatoriaSinSub";
import ConvocatoriaConSub from "./assets/componentes/ConvocatoriaConSub";
import ConvocatoriaSubcategorias from "./assets/componentes/ConvocatoriaSubcategorias";
import FormularioCurso from "./assets/componentes/FormularioCurso";
import Contacto from "./assets/componentes/Contacto";
import AvisoLegal from "./assets/componentes/AvisoLegal";
import PoliticaDePrivacidad from "./assets/componentes/PoliticaDePrivacidad";
import PoliticaDeCookies from "./assets/componentes/PoliticaDeCookies";
import Error404 from "./assets/componentes/Error404";
import ErrorRequest from "./assets/componentes/ErrorRequest";
import Blog from "./assets/componentes/Blog";
import Publicacion from "./assets/componentes/Publicacion";
import Areas from "./assets/componentes/Areas";
import CursosArea from "./assets/componentes/CursosArea";
import CursoAreaDetalle from "./assets/componentes/CursoAreaDetalle";
import { AreasProvider } from "./peticiones_API/Peticiones_Areas";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

WebFont.load({
  google: { families: ["Montserrat", "Dosis", "Roboto", "Open Sans"] },
});


const RutasDinamicas = () => {
  const { categorias, cargaCat } = useContext(CategoriasContext);

  return (
    <>
      <Helmet>
        <title>TusCursosSepe</title>
        <meta name="description" content="CURSOS GRATUITOS.(100% SUBVENCIONADOS). Sea cual sea tu situación laboral, encuentra el curso que mejor se ajuste a tus necesidades." />
      </Helmet>
      <Routes>
        <Route path="/" element={<Cursos />} />
        {!cargaCat &&
          categorias.map((cat) => (
            <React.Fragment key={cat.Id}>
              <Route
                path={`/cursos/${cat.urlCat}`}
                element={<ConvocatoriaSinSub  categoria={cat} />}
              />
              {cat.SubCategoria.length > 0 && (
                <>
                  <Route
                    key={`sub-${cat.Id}`}
                    path={`/cursos/${cat.urlCat}/subcategorias`}
                    element={<ConvocatoriaSubcategorias categoria={cat}/>}
                  />
                  <Route
                    path={`/cursos/${cat.urlCat}/:curso`}
                    element={<ConvocatoriaConSub categoria={cat}/>}
                  />
                </>

              )}
            </React.Fragment>
          ))}
        {/* <Route
          path="/cursos/convocatoria-consorci-2024"
          element={<ConvocatoriaSinSub />}
        />
        <Route
          path="/cursos/convocatoria-ocupados-2024"
          element={<ConvocatoriaSubcategorias />}
        />
        <Route
          path="/cursos/convocatoria-ocupados-2024/:curso"
          element={<ConvocatoriaConSub />}
        /> */}
        <Route
          path="/cursos/:Urlpar_1/:Urlpar_2/:Urlpar_3?"
          element={<FormularioCurso />}
        />
        <Route path="/areas" element={<Areas />} />
        <Route path="/areas/:slug" element={<CursosArea />} />
        <Route path="/areas/:slug/:cursoUrl" element={<CursoAreaDetalle />} />
        <Route path="/contactar" element={<Contacto />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:urlPublicacion" element={<Publicacion />} />

        <Route path="/aviso-legal" element={<AvisoLegal />} />
        <Route path="/politica-de-privacidad" element={<PoliticaDePrivacidad />} />
        <Route path="/politica-de-cookies" element={<PoliticaDeCookies />} />
        <Route path="*" element={<Error404 />} />
        <Route path="/cursos/*" element={<Error404 />} />
        <Route path="/error2" element={<ErrorRequest />} />
      </Routes>
    </>
  );
};

const App = () => {
  return (
    <HelmetProvider>
      <CategoriasProvider>
        <AreasProvider>
          <BrowserRouter>
            <RutasDinamicas />
            <ToastContainer position="bottom-right" autoClose={4000} />
          </BrowserRouter>
        </AreasProvider>
      </CategoriasProvider>
    </HelmetProvider>
  );
};

export default App;